import { createFileRoute } from "@tanstack/react-router";

import { ConfirmPage } from "../../features/orders/confirm-page";

/** The customer's SMS confirmation link (O-03): outside the signed-in and signed-out layouts. */
export const Route = createFileRoute("/c/$token")({ component: ConfirmRoute });

function ConfirmRoute() {
  const { token } = Route.useParams();
  return <ConfirmPage token={token} />;
}
